<template>
  <el-form :model="ruleForm"
           :rules="rules"
           ref="ruleForm"
           class="demo-ruleForm">
    <el-form-item label=""
                  prop="mobile">
      <el-input type="text"
                autocomplete="off"
                v-model="ruleForm.mobile"
                prefix-icon="el-icon-user-solid"
                placeholder="请输入用户名"></el-input>
    </el-form-item>
    <el-form-item label=""
                  prop="password">
      <el-input type="password"
                autocomplete="off"
                v-model="ruleForm.password"
                prefix-icon="el-icon-lock"
                placeholder="请输入至少6位新密码"></el-input>
    </el-form-item>
    <el-form-item label=""
                  prop="code">
      <el-input v-model="ruleForm.code"
                autocomplete="off"
                prefix-icon="el-icon-s-help"
                placeholder="请输入验证码">
        <el-button slot="suffix"
                   class="code"
                   :disabled="disabled"
                   @click="getCode">
          {{ btnTxt }}
        </el-button>
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary"
                 :loading="loading"
                 @click="submitForm('ruleForm')">重置密码
      </el-button>
      <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
    </el-form-item>
  </el-form>
</template>

<script>
import { getForget, getCode } from "@/api/login";

export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码需要超过6位!"));
      } else {
        callback();
      }
    };
    let validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("账号不能为空，请输入邮箱"));
      }
      //使用正则表达式进行验证手机号码
      if (!/^1[3456789]\d{9}$/.test(value) && !/.*?@.*?com$/.test(value))  {
        callback(new Error("账号不正确，请输入邮箱"));
      }
      //自定义校验规则 需要调用callback()函数！
      callback();
    };
    return {
      ruleForm: {
        mobile: "",
        password: "",
        code: "",
      },
      appSecret: "oeuednafwe52edadafdcasdwed",
      rules: {
        mobile: [{ required: true, validator: validatePhone, trigger: "change" }],
        password: [
          { required: true, validator: validatePass, trigger: "change" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "change" }],
      },
      btnTxt: "获取验证码",
      disabled: false,
      time: 0,
      loading: false
    };
  },

  methods: {
    resetNickname () {
      this.$refs["ruleForm"].resetFields()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          var params = {
            mobile: this.ruleForm.mobile,
            code: this.ruleForm.code,
            password: this.ruleForm.password,
          };
          getForget(params).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.loading = false;
              this.$emit("fatherMethod");
            } else {
              this.loading = false;
              //   this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCode () {
      //1.校验手机号码
      if (!this.ruleForm.mobile) {
        //手机号校验不通过
        this.$message({
          message: "请输入手机号码或邮箱！",
          type: "warning",
        });
      } else {
        //2.【手机号码校验通过】发送axios请求 获取验证码
        this.time = 30; //设置倒计时的时间（单位：秒）
        this.disabled = true;
        this.timer(); //调用倒计时方法
        this.getcode();
      }
    },
    getcode () {
      var params = {
        mobile: this.ruleForm.mobile,
        sign: this.$md5(
          "mobile=" +
          this.ruleForm.mobile +
          "&ps=" +
          "&appSecret=" +
          this.appSecret
        ),
      };
      getCode(params).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
        }
      });
    },
    //倒计时方法
    timer () {
      if (this.time > 0) {
        this.time--;
        // console.log(this.time);
        this.btnTxt = this.time + "s后重新获取验证码";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btnTxt = "获取验证码";
        this.disabled = false;
      }
    },
    // resetForm (formName) {
    //   this.$refs[formName].resetFields();
    // },
  },
};
</script>
<style scoped>
/* .btns {
  display: flex;
  justify-content: flex-end;
} */
.el-button--primary {
  width: 100%;
}

.code {
  margin-right: -5px;
}
</style>